export default __webpack_public_path__ + "static/media/presentation.4d5c7aa1.svg";